import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";
import { signOut } from "../../services/authService";
import { PERMISSIONS, USER_DATA } from "../const";
import { clearTokenInformation } from "../helper/auth";
import useAuth from "./useAuth";

const useSignOut = () => {
  const navigate = useNavigate();
  const [signout, setSignout] = useState(false);
  const { setAuth } = useAuth();

  useEffect(() => {
    if (signout) {
      clearTokenInformation();
      setAuth(null);
      localStorage.removeItem(USER_DATA);
      localStorage.removeItem(PERMISSIONS);
      signOut();
      navigate(routes.signin, { replace: true });
    } else {
      setSignout(false);
    }
  }, [signout, setAuth, navigate]);

  return { setSignout };
};

export default useSignOut;
